var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lang",on:{"click":_vm.changeLang}},[_c('GlobeIcon',{class:{changed: _vm.$root.$i18n.locale === 'en'}}),_vm._v(" "+_vm._s(_vm.$t("lang"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }